export default "__VITE_ASSET__BcC0wNbg__"